import { j as p, c as W } from "../../utils-BdNIfrGQ.js";
import * as c from "react";
import fe, { useState as rt, useCallback as oe, useMemo as ot, useEffect as ye } from "react";
import { L as H } from "../../Label-kWLyCHVQ.js";
import { B as Q } from "../../BaseInput-BEfEzQhR.js";
import { I as X } from "../../BaseInput.styles-Bn99zfPn.js";
import { a as it } from "../../Button-CzIiGCVn.js";
import "../../Button.skeleton-D0Onk1OP.js";
import { D as Se } from "../../Div-spVpsZsH.js";
import { T as st } from "../../Text-BhLXzYEf.js";
import { c as ct, a as at, b as ut, s as lt } from "../../TextareaInput-D71C3nBA.js";
import { T as Nn } from "../../TextareaInput-D71C3nBA.js";
import { c as K, g as ft } from "../../_commonjsHelpers-DaMA6jEr.js";
import "../../Div.skeleton-DLnqOZrU.js";
import { F as dt } from "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { c as pt } from "../../createLucideIcon-D4r5Phnh.js";
import { X as mt } from "../../x-BXShoIAM.js";
import { S as Tn } from "../../Switch-DO4qcPoG.js";
import { c as ht } from "../../index-Di82Y7n3.js";
import * as bt from "react-dom";
import { C as vt } from "../../check-BxlvVsvD.js";
const gt = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], xt = pt("search", gt), Ct = fe.forwardRef(
  ({ label: e, helperText: t, error: n, spacing: o, ...r }, s) => /* @__PURE__ */ p.jsxs(X, { spacing: o, children: [
    /* @__PURE__ */ p.jsx(H, { htmlFor: r.id, helperText: t, required: r.required, children: e }),
    /* @__PURE__ */ p.jsx(Q, { ...r, ref: s, type: "email" }),
    n
  ] })
);
Ct.displayName = "Email";
const yt = fe.forwardRef(
  ({ spacing: e, helperText: t, error: n, label: o, ...r }, s) => /* @__PURE__ */ p.jsxs(X, { spacing: e, children: [
    /* @__PURE__ */ p.jsx(H, { htmlFor: r.id, helperText: t, required: r.required, children: o }),
    /* @__PURE__ */ p.jsx(Q, { ...r, ref: s, type: "number" }),
    n
  ] })
);
yt.displayName = "NumberInput";
var ie, Ee;
function St() {
  if (Ee) return ie;
  Ee = 1;
  var e = "Expected a function", t = NaN, n = "[object Symbol]", o = /^\s+|\s+$/g, r = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, i = /^0o[0-7]+$/i, a = parseInt, u = typeof K == "object" && K && K.Object === Object && K, l = typeof self == "object" && self && self.Object === Object && self, m = u || l || Function("return this")(), f = Object.prototype, v = f.toString, h = Math.max, b = Math.min, x = function() {
    return m.Date.now();
  };
  function g(d, y, _) {
    var $, L, F, I, j, N, D = 0, ve = !1, U = !1, te = !0;
    if (typeof d != "function")
      throw new TypeError(e);
    y = E(y) || 0, k(_) && (ve = !!_.leading, U = "maxWait" in _, F = U ? h(E(_.maxWait) || 0, y) : F, te = "trailing" in _ ? !!_.trailing : te);
    function ne(S) {
      var M = $, V = L;
      return $ = L = void 0, D = S, I = d.apply(V, M), I;
    }
    function Qe(S) {
      return D = S, j = setTimeout(Y, y), ve ? ne(S) : I;
    }
    function et(S) {
      var M = S - N, V = S - D, Ce = y - M;
      return U ? b(Ce, F - V) : Ce;
    }
    function ge(S) {
      var M = S - N, V = S - D;
      return N === void 0 || M >= y || M < 0 || U && V >= F;
    }
    function Y() {
      var S = x();
      if (ge(S))
        return xe(S);
      j = setTimeout(Y, et(S));
    }
    function xe(S) {
      return j = void 0, te && $ ? ne(S) : ($ = L = void 0, I);
    }
    function tt() {
      j !== void 0 && clearTimeout(j), D = 0, $ = N = L = j = void 0;
    }
    function nt() {
      return j === void 0 ? I : xe(x());
    }
    function re() {
      var S = x(), M = ge(S);
      if ($ = arguments, L = this, N = S, M) {
        if (j === void 0)
          return Qe(N);
        if (U)
          return j = setTimeout(Y, y), ne(N);
      }
      return j === void 0 && (j = setTimeout(Y, y)), I;
    }
    return re.cancel = tt, re.flush = nt, re;
  }
  function k(d) {
    var y = typeof d;
    return !!d && (y == "object" || y == "function");
  }
  function R(d) {
    return !!d && typeof d == "object";
  }
  function C(d) {
    return typeof d == "symbol" || R(d) && v.call(d) == n;
  }
  function E(d) {
    if (typeof d == "number")
      return d;
    if (C(d))
      return t;
    if (k(d)) {
      var y = typeof d.valueOf == "function" ? d.valueOf() : d;
      d = k(y) ? y + "" : y;
    }
    if (typeof d != "string")
      return d === 0 ? d : +d;
    d = d.replace(o, "");
    var _ = s.test(d);
    return _ || i.test(d) ? a(d.slice(2), _ ? 2 : 8) : r.test(d) ? t : +d;
  }
  return ie = g, ie;
}
var Et = St();
const _t = /* @__PURE__ */ ft(Et), je = ({
  id: e,
  label: t,
  value: n = "",
  debounceMillis: o = 300,
  onSearch: r,
  onClear: s,
  onChange: i,
  variant: a,
  hideLabel: u = !1,
  ariaLabelClear: l = "Clear search",
  clearText: m,
  ...f
}) => {
  const [v, h] = rt(() => String(n)), b = typeof t.children == "string" ? t.children : void 0, x = oe(
    (E) => {
      r(E);
    },
    [r]
  ), g = ot(
    () => _t(x, o, { trailing: !0 }),
    [x, o]
  );
  ye(() => {
    h(String(n));
  }, [n]), ye(() => () => g.cancel(), [g]);
  const k = oe(
    (E) => {
      const d = E.target.value;
      h(d), i?.(E), g(d);
    },
    [i, g]
  ), R = oe(() => {
    h(""), g.cancel(), r(""), s?.();
  }, [r, s, g]), C = a ? ct[a] : { variant: "ghost", size: "icon" };
  return /* @__PURE__ */ p.jsxs(X, { size: "full", children: [
    /* @__PURE__ */ p.jsx(
      H,
      {
        htmlFor: e,
        ...t,
        fontWeight: "inherit",
        variant: u ? "hidden" : "visible"
      }
    ),
    /* @__PURE__ */ p.jsxs(dt, { className: W(lt({ variant: a })), children: [
      /* @__PURE__ */ p.jsx(xt, { className: "text-gray-600", "aria-hidden": "true" }),
      /* @__PURE__ */ p.jsx(
        Q,
        {
          ...f,
          id: e,
          type: "search",
          className: "border-none appearance-none outline-none bg-transparent pl-4 w-full focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 [&::-webkit-search-cancel-button]:hidden [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:hidden",
          role: "searchbox",
          "aria-label": b,
          onChange: k,
          value: v
        }
      ),
      v && /* @__PURE__ */ p.jsx(Se, { className: W(ut({ variant: a })), children: /* @__PURE__ */ p.jsxs(
        it,
        {
          variant: C.variant,
          "aria-label": l,
          onClick: R,
          size: C.size,
          children: [
            /* @__PURE__ */ p.jsx(mt, { size: 16 }),
            /* @__PURE__ */ p.jsx(Se, { className: W(at({ variant: a })), children: /* @__PURE__ */ p.jsx(st, { size: "sm", fontWeight: "semibold", children: m }) })
          ]
        }
      ) })
    ] })
  ] });
}, kn = ({
  id: e,
  label: t,
  hideLabel: n = !1,
  ariaLabelClear: o,
  value: r = "",
  onSearch: s,
  onClear: i,
  onChange: a,
  debounceMillis: u = 300,
  ...l
}) => /* @__PURE__ */ p.jsx(
  je,
  {
    ...l,
    id: e,
    label: t,
    value: r,
    onSearch: s,
    onClear: i,
    onChange: a,
    debounceMillis: u,
    hideLabel: n,
    ariaLabelClear: o
  }
), Rn = ({ id: e, label: t, clearText: n, ...o }) => /* @__PURE__ */ p.jsx(je, { ...o, id: e, label: t, clearText: n, variant: "cta" }), kt = fe.forwardRef(
  ({ label: e, helperText: t, error: n, spacing: o, ...r }, s) => /* @__PURE__ */ p.jsxs(X, { spacing: o, children: [
    /* @__PURE__ */ p.jsx(H, { htmlFor: r.id, helperText: t, required: r.required, children: e }),
    /* @__PURE__ */ p.jsx(Q, { ...r, type: "text", ref: s }),
    n
  ] })
);
kt.displayName = "TextInput";
const se = "data-[state=checked]:bg-checkbox data-[state=checked]:border-checkbox data-[state=checked]:text-checkbox-foreground", Rt = ht("h-8 w-8 shadow-none bg-clip-border", {
  variants: {
    variant: {
      default: `border-2 border-muted-foreground ${se}`,
      primary: `border-2 border-primary ${se}`,
      light: `border border-muted-foreground ${se}`
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var jt = Object.defineProperty, de = (e, t) => jt(e, "name", { value: t, configurable: !0 });
function ce(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
de(ce, "setRef");
function Pe(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const s = ce(r, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const s = o[r];
          typeof s == "function" ? s() : ce(e[r], null);
        }
      };
  };
}
de(Pe, "composeRefs");
function ee(...e) {
  return c.useCallback(Pe(...e), e);
}
de(ee, "useComposedRefs");
var Pt = Object.defineProperty, P = (e, t) => Pt(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function wt(e, t) {
  const n = c.createContext(t);
  n.displayName = e + "Context";
  const o = /* @__PURE__ */ P((s) => {
    const { children: i, ...a } = s, u = c.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ p.jsx(n.Provider, { value: u, children: i });
  }, "Provider");
  o.displayName = e + "Provider";
  function r(s, i = {}) {
    const { optional: a = !1 } = i, u = c.useContext(n);
    if (u) return u;
    if (t !== void 0) return t;
    if (!a)
      throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return P(r, "useContext"), [o, r];
}
P(wt, "createContext");
// @__NO_SIDE_EFFECTS__
function we(e, t = []) {
  let n = [];
  function o(s, i) {
    const a = c.createContext(i);
    a.displayName = s + "Context";
    const u = n.length;
    n = [...n, i];
    const l = /* @__PURE__ */ P((f) => {
      const { scope: v, children: h, ...b } = f, x = v?.[e]?.[u] || a, g = c.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ p.jsx(x.Provider, { value: g, children: h });
    }, "Provider");
    l.displayName = s + "Provider";
    function m(f, v, h = {}) {
      const { optional: b = !1 } = h, x = v?.[e]?.[u] || a, g = c.useContext(x);
      if (g) return g;
      if (i !== void 0) return i;
      if (!b)
        throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return P(m, "useContext"), [l, m];
  }
  P(o, "createContext");
  const r = /* @__PURE__ */ P(() => {
    const s = n.map((i) => c.createContext(i));
    return /* @__PURE__ */ P(function(a) {
      const u = a?.[e] || s;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: u } }),
        [a, u]
      );
    }, "useScope");
  }, "createScope");
  return r.scopeName = e, [o, Ie(r, ...t)];
}
P(we, "createContextScope");
function Ie(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = /* @__PURE__ */ P(() => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return /* @__PURE__ */ P(function(s) {
      const i = o.reduce((a, { useScope: u, scopeName: l }) => {
        const f = u(s)[`__scope${l}`];
        return { ...a, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    }, "useComposedScopes");
  }, "createScope");
  return n.scopeName = t.scopeName, n;
}
P(Ie, "composeContextScopes");
var It = Object.defineProperty, z = (e, t) => It(e, "name", { value: t, configurable: !0 }), Ne = !!(typeof window < "u" && window.document && window.document.createElement);
function J(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return /* @__PURE__ */ z(function(r) {
    if (e?.(r), n === !1 || !r || !r.defaultPrevented)
      return t?.(r);
  }, "handleEvent");
}
z(J, "composeEventHandlers");
function Nt(e) {
  if (!Ne)
    throw new Error("Cannot access window outside of the DOM");
  return e?.ownerDocument?.defaultView ?? window;
}
z(Nt, "getOwnerWindow");
function ae(e) {
  if (!Ne)
    throw new Error("Cannot access document outside of the DOM");
  return e?.ownerDocument ?? document;
}
z(ae, "getOwnerDocument");
function Oe(e, t = !1) {
  const { activeElement: n } = ae(e);
  if (!n?.nodeName)
    return null;
  if (Te(n) && n.contentDocument)
    return Oe(n.contentDocument.body, t);
  if (t) {
    const o = n.getAttribute("aria-activedescendant");
    if (o) {
      const r = ae(n).getElementById(o);
      if (r)
        return r;
    }
  }
  return n;
}
z(Oe, "getActiveElement");
function Te(e) {
  return e.tagName === "IFRAME";
}
z(Te, "isFrame");
var q = globalThis?.document ? c.useLayoutEffect : () => {
}, Ot = Object.defineProperty, Tt = (e, t) => Ot(e, "name", { value: t, configurable: !0 }), _e = c[" useEffectEvent ".trim().toString()], ke = c[" useInsertionEffect ".trim().toString()];
function Ae(e) {
  if (typeof _e == "function")
    return _e(e);
  const t = c.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return typeof ke == "function" ? ke(() => {
    t.current = e;
  }) : q(() => {
    t.current = e;
  }), c.useMemo(() => ((...n) => t.current?.(...n)), []);
}
Tt(Ae, "useEffectEvent");
var At = Object.defineProperty, G = (e, t) => At(e, "name", { value: t, configurable: !0 }), $t = c[" useInsertionEffect ".trim().toString()] || q;
function $e({
  prop: e,
  defaultProp: t,
  onChange: n = /* @__PURE__ */ G(() => {
  }, "onChange"),
  caller: o
}) {
  const [r, s, i] = Me({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, u = a ? e : r, l = c.useCallback(
    (m) => {
      if (a) {
        const f = Fe(m) ? m(e) : m;
        f !== e && i.current?.(f);
      } else
        s(m);
    },
    [a, e, s, i]
  );
  return [u, l];
}
G($e, "useControllableState");
function Me({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = c.useState(e), r = c.useRef(n), s = c.useRef(t);
  return $t(() => {
    s.current = t;
  }, [t]), c.useEffect(() => {
    r.current !== n && (s.current?.(n), r.current = n);
  }, [n, r]), [n, o, s];
}
G(Me, "useUncontrolledState");
function Fe(e) {
  return typeof e == "function";
}
G(Fe, "isFunction");
var Re = /* @__PURE__ */ Symbol("RADIX:SYNC_STATE");
function Mt(e, t, n, o) {
  const { prop: r, defaultProp: s, onChange: i, caller: a } = t, u = r !== void 0, l = Ae(i), m = [{ ...n, state: s }];
  o && m.push(o);
  const [f, v] = c.useReducer(
    (g, k) => {
      if (k.type === Re)
        return { ...g, state: k.state };
      const R = e(g, k);
      return u && !Object.is(R.state, g.state) && l(R.state), R;
    },
    ...m
  ), h = f.state, b = c.useRef(h);
  c.useEffect(() => {
    b.current !== h && (b.current = h, u || l(h));
  }, [h, b, u]);
  const x = c.useMemo(() => r !== void 0 ? { ...f, state: r } : f, [f, r]);
  return c.useEffect(() => {
    u && !Object.is(r, f.state) && v({ type: Re, state: r });
  }, [r, f.state, u]), [x, v];
}
G(Mt, "useControllableStateReducer");
var Ft = Object.defineProperty, Dt = (e, t) => Ft(e, "name", { value: t, configurable: !0 });
function De(e) {
  const [t, n] = c.useState(void 0);
  return q(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const s = r[0];
        let i, a;
        if ("borderBoxSize" in s) {
          const u = s.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          i = l.inlineSize, a = l.blockSize;
        } else
          i = e.offsetWidth, a = e.offsetHeight;
        n({ width: i, height: a });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
Dt(De, "useSize");
var Lt = Object.defineProperty, T = (e, t) => Lt(e, "name", { value: t, configurable: !0 });
function Le(e, t) {
  return c.useReducer((n, o) => t[n][o] ?? n, e);
}
T(Le, "useStateMachine");
var Bt = /* @__PURE__ */ T((e) => {
  const { present: t, children: n } = e, o = Be(t), r = typeof n == "function" ? n({ present: o.isPresent }) : c.Children.only(n), s = We(o.ref, ze(r));
  return typeof n == "function" || o.isPresent ? c.cloneElement(r, { ref: s }) : null;
}, "Presence");
function Be(e) {
  const [t, n] = c.useState(), o = c.useRef(null), r = c.useRef(e), s = c.useRef("none"), i = c.useRef(void 0), a = e ? "mounted" : "unmounted", [u, l] = Le(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    u === "mounted" ? (s.current = i.current ?? B(o.current), i.current = void 0) : s.current = "none";
  }, [u]), q(() => {
    const m = o.current, f = r.current;
    if (f !== e) {
      const h = s.current, b = B(m);
      e ? (i.current = b, l("MOUNT")) : b === "none" || m?.display === "none" ? l("UNMOUNT") : l(f && h !== b ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), q(() => {
    if (t) {
      let m;
      const f = t.ownerDocument.defaultView ?? window, v = /* @__PURE__ */ T((b) => {
        const g = B(o.current).includes(CSS.escape(b.animationName));
        if (b.target === t && g && (l("ANIMATION_END"), !r.current)) {
          const k = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", m = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = k);
          });
        }
      }, "handleAnimationEnd"), h = /* @__PURE__ */ T((b) => {
        b.target === t && (s.current = B(o.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        f.clearTimeout(m), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(u),
    ref: c.useCallback((m) => {
      if (m) {
        const f = getComputedStyle(m);
        o.current = f, i.current = B(f);
      } else
        o.current = null;
      n(m);
    }, [])
  };
}
T(Be, "usePresence");
function ue(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
T(ue, "setRef");
function We(...e) {
  const t = c.useRef(e);
  return t.current = e, c.useCallback((n) => {
    const o = t.current;
    let r = !1;
    const s = o.map((i) => {
      const a = ue(i, n);
      return !r && typeof a == "function" && (r = !0), a;
    });
    if (r)
      return () => {
        for (let i = 0; i < s.length; i++) {
          const a = s[i];
          typeof a == "function" ? a() : ue(o[i], null);
        }
      };
  }, []);
}
T(We, "useStableComposedRefs");
function B(e) {
  return e?.animationName || "none";
}
T(B, "getAnimationName");
function ze(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
T(ze, "getElementRef");
var Wt = Object.defineProperty, w = (e, t) => Wt(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function Ue(e) {
  const t = c.forwardRef((n, o) => {
    let { children: r, ...s } = n, i = null, a = !1;
    const u = [];
    le(r) && typeof Z == "function" && (r = Z(r._payload)), c.Children.forEach(r, (v) => {
      if (Xe(v)) {
        a = !0;
        const h = v;
        let b = "child" in h.props ? h.props.child : h.props.children;
        le(b) && typeof Z == "function" && (b = Z(b._payload)), i = Ut(h, b), u.push(i?.props?.children);
      } else
        u.push(v);
    }), i ? i = c.cloneElement(i, void 0, u) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !a && c.Children.count(r) === 1 && c.isValidElement(r) && (i = r)
    );
    const l = i ? He(i) : void 0, m = ee(o, l);
    if (!i) {
      if (r || r === 0)
        throw new Error(
          a ? Ht(e) : qt(e)
        );
      return r;
    }
    const f = qe(s, i.props ?? {});
    return i.type !== c.Fragment && (f.ref = o ? m : l), c.cloneElement(i, f);
  });
  return t.displayName = `${e}.Slot`, t;
}
w(Ue, "createSlot");
var Ve = /* @__PURE__ */ Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function zt(e) {
  const t = /* @__PURE__ */ w((n) => "child" in n ? n.children(n.child) : n.children, "Slottable");
  return t.displayName = `${e}.Slottable`, t.__radixId = Ve, t;
}
w(zt, "createSlottable");
var Ut = /* @__PURE__ */ w((e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return c.isValidElement(n) ? c.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
  }
  return c.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function qe(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], s = t[o];
    /^on[A-Z]/.test(o) ? r && s ? n[o] = (...a) => {
      const u = s(...a);
      return r(...a), u;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...s } : o === "className" && (n[o] = [r, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
w(qe, "mergeProps");
function He(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
w(He, "getElementRef");
function Xe(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ve;
}
w(Xe, "isSlottable");
var Vt = /* @__PURE__ */ Symbol.for("react.lazy");
function le(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Vt && "_payload" in e && Ge(e._payload);
}
w(le, "isLazyComponent");
function Ge(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
w(Ge, "isPromiseLike");
var qt = /* @__PURE__ */ w((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), Ht = /* @__PURE__ */ w((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Z = c[" use ".trim().toString()], Xt = Object.defineProperty, Gt = (e, t) => Xt(e, "name", { value: t, configurable: !0 }), Yt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], pe = Yt.reduce((e, t) => {
  const n = /* @__PURE__ */ Ue(`Primitive.${t}`), o = c.forwardRef((r, s) => {
    const { asChild: i, ...a } = r, u = i ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p.jsx(u, { ...a, ref: s });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Kt(e, t) {
  e && bt.flushSync(() => e.dispatchEvent(t));
}
Gt(Kt, "dispatchDiscreteCustomEvent");
var Zt = Object.defineProperty, A = (e, t) => Zt(e, "name", { value: t, configurable: !0 }), me = "Checkbox", [Jt, jn] = /* @__PURE__ */ we(me), [Qt, he] = Jt(me);
function Ye(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: o,
    defaultChecked: r,
    disabled: s,
    form: i,
    name: a,
    onCheckedChange: u,
    required: l,
    value: m = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [v, h] = $e({
    prop: n,
    defaultProp: r ?? !1,
    onChange: u,
    caller: me
  }), [b, x] = c.useState(null), [g, k] = c.useState(null), R = c.useRef(!1), [C, E] = c.useReducer(
    (_) => _ + 1,
    0
  ), d = b ? !!i || !!b.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), y = {
    checked: v,
    disabled: s,
    setChecked: h,
    control: b,
    setControl: x,
    name: a,
    form: i,
    value: m,
    hasConsumerStoppedPropagationRef: R,
    userInteractionCount: C,
    onUserInteraction: E,
    required: l,
    defaultChecked: O(r) ? !1 : r,
    isFormControl: d,
    bubbleInput: g,
    setBubbleInput: k
  };
  return /* @__PURE__ */ p.jsx(
    Qt,
    {
      scope: t,
      ...y,
      children: Ze(f) ? f(y) : o
    }
  );
}
A(Ye, "CheckboxProvider");
var en = "CheckboxTrigger", tn = /* @__PURE__ */ c.forwardRef(
  /* @__PURE__ */ A(function({ __scopeCheckbox: t, onKeyDown: n, onClick: o, ...r }, s) {
    const {
      control: i,
      value: a,
      disabled: u,
      checked: l,
      required: m,
      setControl: f,
      setChecked: v,
      hasConsumerStoppedPropagationRef: h,
      onUserInteraction: b,
      isFormControl: x,
      bubbleInput: g
    } = he(en, t), k = ee(s, f), R = c.useRef(l);
    return c.useEffect(() => {
      const C = i?.form;
      if (C) {
        const E = /* @__PURE__ */ A(() => v(R.current), "reset");
        return C.addEventListener("reset", E), () => C.removeEventListener("reset", E);
      }
    }, [i, v]), /* @__PURE__ */ p.jsx(
      pe.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": O(l) ? "mixed" : l,
        "aria-required": m,
        "data-state": be(l),
        "data-disabled": u ? "" : void 0,
        disabled: u,
        value: a,
        ...r,
        ref: k,
        onKeyDown: J(n, (C) => {
          C.key === "Enter" && C.preventDefault();
        }),
        onClick: J(o, (C) => {
          b(), v((E) => O(E) ? !0 : !E), g && x && (h.current = C.isPropagationStopped(), h.current || C.stopPropagation());
        })
      }
    );
  }, "CheckboxTrigger")
), Ke = /* @__PURE__ */ c.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ A(function(t, n) {
    const {
      __scopeCheckbox: o,
      name: r,
      checked: s,
      defaultChecked: i,
      required: a,
      disabled: u,
      value: l,
      onCheckedChange: m,
      form: f,
      ...v
    } = t;
    return /* @__PURE__ */ p.jsx(
      Ye,
      {
        __scopeCheckbox: o,
        checked: s,
        defaultChecked: i,
        disabled: u,
        required: a,
        onCheckedChange: m,
        name: r,
        form: f,
        value: l,
        internal_do_not_use_render: ({ isFormControl: h }) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            tn,
            {
              ...v,
              ref: n,
              __scopeCheckbox: o
            }
          ),
          h && /* @__PURE__ */ p.jsx(
            sn,
            {
              __scopeCheckbox: o
            }
          )
        ] })
      }
    );
  }, "Checkbox")
), nn = "CheckboxIndicator", rn = /* @__PURE__ */ c.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ A(function(t, n) {
    const { __scopeCheckbox: o, forceMount: r, ...s } = t, i = he(nn, o);
    return /* @__PURE__ */ p.jsx(
      Bt,
      {
        present: r || O(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ p.jsx(
          pe.span,
          {
            "data-state": be(i.checked),
            "data-disabled": i.disabled ? "" : void 0,
            ...s,
            ref: n,
            style: { pointerEvents: "none", ...t.style }
          }
        )
      }
    );
  }, "CheckboxIndicator")
), on = "CheckboxBubbleInput", sn = /* @__PURE__ */ c.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ A(function({ __scopeCheckbox: t, onClick: n, ...o }, r) {
    const {
      control: s,
      hasConsumerStoppedPropagationRef: i,
      userInteractionCount: a,
      checked: u,
      defaultChecked: l,
      required: m,
      disabled: f,
      name: v,
      value: h,
      form: b,
      bubbleInput: x,
      setBubbleInput: g
    } = he(on, t), k = ee(r, g), R = De(s), C = c.useRef(!1), E = c.useRef(u), d = c.useRef(a);
    c.useEffect(() => {
      const _ = x;
      if (!_) return;
      const $ = window.HTMLInputElement.prototype, F = Object.getOwnPropertyDescriptor(
        $,
        "checked"
      ).set, I = a !== d.current;
      d.current = a;
      const j = E.current !== u;
      E.current = u;
      const N = !(I && i.current);
      if (j && F) {
        C.current = !I;
        const D = new Event("click", { bubbles: N });
        _.indeterminate = O(u), F.call(_, O(u) ? !1 : u), _.dispatchEvent(D), C.current = !1;
      }
    }, [x, u, i, a]);
    const y = c.useRef(O(u) ? !1 : u);
    return /* @__PURE__ */ p.jsx(
      pe.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: l ?? y.current,
        required: m,
        disabled: f,
        name: v,
        value: h,
        form: b,
        ...o,
        tabIndex: -1,
        ref: k,
        onClick: J(n, (_) => {
          C.current && _.stopPropagation();
        }),
        style: {
          ...o.style,
          ...R,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }, "CheckboxBubbleInput")
);
function Ze(e) {
  return typeof e == "function";
}
A(Ze, "isFunction");
function O(e) {
  return e === "indeterminate";
}
A(O, "isIndeterminate");
function be(e) {
  return O(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
A(be, "getState");
const Je = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  Ke,
  {
    ref: n,
    className: W(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p.jsx(rn, { className: W("flex items-center justify-center text-current"), children: /* @__PURE__ */ p.jsx(vt, { className: "h-7 w-7", strokeWidth: 3 }) })
  }
));
Je.displayName = Ke.displayName;
const Pn = ({
  id: e,
  label: t,
  helperText: n,
  error: o,
  hideLabel: r,
  variant: s,
  align: i,
  ...a
}) => {
  const u = r === !0 ? "hidden" : "visible";
  return /* @__PURE__ */ p.jsxs(X, { align: i, children: [
    /* @__PURE__ */ p.jsx(H, { htmlFor: e, variant: u, helperText: n, children: t }),
    /* @__PURE__ */ p.jsx(Je, { id: e, className: W(Rt({ variant: s })), ...a }),
    o
  ] });
};
export {
  Pn as Checkbox,
  Ct as Email,
  yt as NumberInput,
  Rn as SearchCTA,
  kn as SearchInput,
  Tn as Switch,
  kt as TextInput,
  Nn as TextareaInput
};
